<template>
  <div>
    <div class="aboutMeBox">
      <div class="publicHead"><b></b><span>过来人档案</span></div>
      <div class="archives">
        <div v-if="seniorDetail.pgCollege">研究生院校：{{seniorDetail.pgCollege}}</div>
        <div v-if="seniorDetail.pgSubject">研究生专业：{{seniorDetail.pgSubject}}</div>
        <div v-if="seniorDetail.initExamScore">初试分数：{{seniorDetail.initExamScore||"-"}}</div>
        <div v-if="seniorDetail.dataType">硕士类型：{{seniorDetail.dataType===1?`学硕`:`专硕`}}</div>
        <div v-if="seniorDetail.enrolYear">入学年份：{{seniorDetail.enrolYear}}</div>
      </div>
    </div>
    <div
      class="aboutMeBox"
      v-if="seniorDetail.profile"
    >
      <div class="publicHead"><b></b><span>个人简介</span></div>
      <div class="archives">
        <div>{{seniorDetail.profile}}</div>
      </div>
    </div>
    <div
      class="aboutMeBox"
      v-if="seniorDetail.feedback"
    >
      <div class="publicHead"><b></b><span>我已经帮助过TA们</span></div>
      <div class="archivesRich">
        <div v-html="seniorDetail.feedback"></div>
      </div>
    </div>
    <div class="quickMatch">
      <div @click="openChat()">我想要1v1试听</div>
    </div>
  </div>
</template>

<script>
import { seniorOpenChat } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  component: {
  },
  props: {
    seniorDetail: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {

    };
  },

  computed: {

  },
  mounted() {
  },

  methods: {
    // 我想要1v1试听
    openChat() {
      if (this.$root.whatEev == 'miniprogram') {
        wx.miniProgram.navigateTo({ url: '/subPackages/aiChatWebview/index?probeId=33' });
      } else {
        if(this.$route.query.source==='oneToOne'){
          this.openOneToOne();
        }else{
          seniorOpenChat(this);
        }

      }
    },
    openOneToOne(){
           const url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66e39b2a165a0b00012736b4';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.$data.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    }

  },
};

</script>

<style lang="scss" scoped>
.aboutMeBox {
  margin-top: 22px;
  background: #fff;
  border-radius: 14px;
  .publicHead {
    width: 100%;
    padding: 24px 0;
    font-size: 0;
    background: #fff;
    border-bottom: 2px solid #f8f8f8;
    border-radius: 14px 14px 0 0;
    b {
      display: inline-block;
      width: 6px;
      height: 29px;
      margin-right: 30px;
      background: #ff7f41;
      border-radius: 0 5px 5px 0;
    }
    span {
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      vertical-align: 4px;
    }
  }
  .archives {
    box-sizing: border-box;
    padding: 0 33px;
    > div {
      padding: 25px 0;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
      border-bottom: 2px solid #f8f8f8;
    }
  }
  .archivesRich {
    box-sizing: border-box;
    padding: 0 33px;
    > div {
      ::v-deep img {
        max-width: 100%;
      }
    }
  }
}
.quickMatch {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 35px 0 50px 0;
  background: #fff;
  border-radius: 29px 29px 2px 2px;
  box-shadow: 0 -4px 18px 0 rgba(0, 0, 0, 0.07);
  div {
    width: 678px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 45px;
  }
}
</style>
